import { render, staticRenderFns } from "./asset-group.vue?vue&type=template&id=61494753&scoped=true&"
import script from "./asset-group.vue?vue&type=script&lang=js&"
export * from "./asset-group.vue?vue&type=script&lang=js&"
import style0 from "./asset-group.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./asset-group.vue?vue&type=style&index=1&id=61494753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61494753",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VRow})
